<template>
<!-- 企业理念 -->
  <div>
    <bread :list="list" :list1="list1" />
     <div class="linian-wap">
         <drugswiper />
     </div>
  </div>
</template>
<script>
import bread from "../../components/home/bread";
import drugswiper from '../../components/home/drugswiper'
export default {
  data() {
    return {
      list: [{ name: "首页", src: "/" }],
      list1: { name: "企业理念", src: "/about/linian" }
    };
  },
  components: {
    bread,drugswiper
  }
};
</script>
<style lang="scss">
.linian-wap{
    width: 100%;
    margin-top: 19px;
    margin-bottom: 40px;
}
</style>